/**
 * The app index
 */
import React from "react";
import { render, hydrate } from "react-dom";
import { Provider, useSelector } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { Web3ReactProvider } from "@web3-react/core";
import Loadable from "react-loadable";
import I18n from "redux-i18n";
import { createSsr } from "@issr/core";
import "./index.sass";
import "font-awesome/css/font-awesome.min.css";
import "@solana/wallet-adapter-react-ui/styles.css";
import { rootSaga } from "@bkry/bowline-redux";
import { configureStore, isServer } from "@bkry/bowline-redux";
// import { configureWorker } from "@bkry/bowline-utils";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
// import { translations } from "./locales/translations";
import Root from "./routes/Root";
// import { ethers } from "ethers";
import { metaMaskHooks, metaMask } from "@bkry/bowline-connectors";
import { coinBaseHooks, coinBase } from "@bkry/bowline-connectors";
import { walletConnectHooks, walletConnect } from "@bkry/bowline-connectors";
import { googleWalletHooks, googleWallet } from "@bkry/bowline-connectors";
import { fbWalletHooks, fbWallet } from "@bkry/bowline-connectors";
import { ledgerHooks, ledgerWallet } from "@bkry/bowline-connectors";

import { SolanaProvider } from "./providers/solana";

/** create a store */
const { store, history } = configureStore();

/** run sagas */
store.runSaga(rootSaga);

const connectors = {
  metamask: [metaMask, metaMaskHooks],
  "wta-google": [googleWallet, googleWalletHooks],
  coinbase: [coinBase, coinBaseHooks],
  "wallet-connect": [walletConnect, walletConnectHooks],
  "wta-fb": [fbWallet, fbWalletHooks],
  ledger: [ledgerWallet, ledgerHooks],
};
const localStorageLastProvider = localStorage.getItem("lastProvider");
const connectorsList = [];
if (localStorageLastProvider && connectors[localStorageLastProvider]) {
  connectorsList.push(connectors[localStorageLastProvider]);
}
Object.entries(connectors).forEach(([key, value]) => {
  if (key !== localStorageLastProvider) {
    connectorsList.push(value);
  }
});

const SSR = createSsr();

/** The application */
const Application = () => {
  const { translations, lang } = useSelector((state) => state.i18nState);
  return (
    <SolanaProvider>
      <Web3ReactProvider connectors={connectorsList}>
        <I18n
          translations={translations}
          initialLang={lang}
          initialized={!!translations[lang]}
        >
          <ConnectedRouter history={history}>
            <Root />
          </ConnectedRouter>
        </I18n>
      </Web3ReactProvider>
    </SolanaProvider>
  );
};

/** the root element to load react */
const root = document.querySelector("#root");

/**
 * the index main
 */
if (root.hasChildNodes() === true) {
  // If it's an SSR, we use hydrate to get fast page loads by just
  // attaching event listeners after the initial render
  Loadable.preloadReady().then(() => {
    hydrate(
      <SSR>
        <Provider store={store}>
          <Application />
        </Provider>
      </SSR>,
      root
    );
  });
} else {
  // If we're not running on the server, just render like normal
  render(
    <SSR>
      <Provider store={store}>
        <Application />
      </Provider>
    </SSR>,
    root
  );
}

/** build the service worker configuration object */
// var config = configureWorker(store);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
if (!isServer) {
  // serviceWorkerRegistration.register(config);
  serviceWorkerRegistration.unregister();
} else {
  serviceWorkerRegistration.unregister();
}
